import React from 'react';
import { PropTypes } from 'prop-types';

import { Button } from '@ontruck/orc';

import LoadSpinner from 'components/LoadSpinner';
import LiteralCurrency from 'components/LiteralCurrency';

import ErrorMessage from 'components/ErrorMessage';
import TimeErrorModal from 'components/summary/TimeErrorModal';

import BillingInfoForm from 'components/PaymentData/BillingInfoForm';
import PaymentMethodSelector from 'components/PaymentData/PaymentMethodSelector';

import validatePaymentData from 'utils/paymentData/validators/validatePaymentData';
import { isEmpty } from 'utils/types';

class PaymentDataForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: undefined,
      isLoading: false,
    };
  }

  handleSubmit = async (ev) => {
    ev.preventDefault();
    this.setState({ isLoading: true });
    const { paymentData, handleSubmit, country } = this.props;
    const countryCode = (country && country.country) || false;
    const { errors } = validatePaymentData({
      paymentData,
      country: countryCode,
    });
    this.setState({ isLoading: true, errors });
    if (isEmpty(errors)) {
      handleSubmit();
    }
    this.setState({ isLoading: false });
  };

  render() {
    const {
      t,
      fullPrice,
      hasQuoteError,
      isSubmitting,
      hasPastError,
      hasErrors,
    } = this.props;
    const { errors, isLoading } = this.state;
    return (
      <form>
        <BillingInfoForm errors={errors} />
        <PaymentMethodSelector
          errors={errors}
          CardComponent={<div className="block" />}
        />

        {hasPastError && <TimeErrorModal t={t} />}

        {hasErrors || hasQuoteError ? (
          <ErrorMessage t={t} />
        ) : (
          <div className="summary">
            <div className="vat-value">
              {t('CreditCard:price_with_vat')}
              <div className="price">
                <LiteralCurrency value={fullPrice} />{' '}
              </div>
            </div>

            <Button
              text={
                isLoading || isSubmitting ? (
                  <LoadSpinner skin="inButton" />
                ) : (
                  t('CreditCard:pay_and_confirm')
                )
              }
              type="button"
              size="L"
              disabled={isLoading || isSubmitting}
              onClick={this.handleSubmit}
            />
          </div>
        )}
      </form>
    );
  }
}

PaymentDataForm.propTypes = {
  t: PropTypes.func,

  fullPrice: PropTypes.number,
  isSubmitting: PropTypes.bool,
  hasPastError: PropTypes.bool,
  hasQuoteError: PropTypes.bool,
  hasErrors: PropTypes.bool,
  paymentData: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func,
  country: PropTypes.string,
};

PaymentDataForm.defaultProps = {
  t: (t) => t,

  fullPrice: 0,
  isSubmitting: false,
  hasPastError: false,
  hasQuoteError: false,
  hasErrors: false,
  handleSubmit: () => ({}),
  country: '',
};

export default PaymentDataForm;
